import classNames from 'classnames';
import React, { FC } from 'react';
import { CardSection, CardSectionProps } from './CardSection';

export const CardBar: FC<CardSectionProps> = ({ children, className, ...props }) => (
  <CardSection className={classNames(`card__bar border-b flex items-center justify-between`, className)} {...props}>
    {children}
  </CardSection>
);
